import { useEffect } from "react";
import { useAfterPaint } from "hooks/use-after-paint";
import { useSelector } from "hooks/use-selector";
import { useLocation } from "react-router-dom";
import { selectDestinations } from "store/quote/selectors";
import { trackPageView } from "utils/tracking";
import { mixpanelTrack, updateMixpanelUser } from "utils/tracking/mixpanel";
import { isOnboardingCtaInView } from "utils/tracking/utils";
import { type PlaceDetails } from "types/quote-types";

export function trackSubmit(destinations: PlaceDetails[]) {
  const names = destinations.map((destination) => destination.label);

  updateMixpanelUser({
    searched_destinations: names,
  });

  mixpanelTrack("setting_destination", {
    destinations: names,
    is_multiple_destinations: destinations.length > 1,
  });
}

export function useTracking({
  ctaEnabled,
  formName,
}: {
  ctaEnabled: boolean;
  formName?: string;
}) {
  const { pathname } = useLocation();
  const destinations = useSelector(selectDestinations);
  const hasPainted = useAfterPaint();

  useEffect(() => {
    if (hasPainted) {
      trackPageView("Destinations", pathname, {
        destinations_filled: Boolean(destinations?.length),
        destinations_count: destinations?.length ?? 0,
        cta_enabled: ctaEnabled,
        cta_in_viewport: isOnboardingCtaInView(formName),
      });
    }
  }, [pathname, hasPainted]);
}
